import { useRef, useEffect, useState } from 'react'
import { Box } from '@material-ui/core'
import MuiAlert from '@material-ui/lab/Alert'
import Upload from '../../svgs/upload'
import FilledButton from '../FilledButton'
import Snackbar from '@material-ui/core/Snackbar'
import _ from 'lodash'
import DownloadForm from '../DownloadForm'
import { useStyles } from './styles'

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />
}
const UploadFile = (props) => {
  const classes = useStyles()
  var {
    uploadfiledescription,
    onValueChange,
    existingfilename,
    existingfileurl,
    ...rest
  } = props
  const hiddenFileInput = useRef(null)
  useEffect(() => {
    hiddenFileInput.current.value = null
    if (existingfilename) setEditFile(true)
  }, [])
  const [filename, setFileName] = useState(null)
  const [openSnackBar, setOpenSnackBar] = useState(false)
  const [snackBarType, setSnackBarType] = useState(null)
  const [editFile, setEditFile] = useState(false)
  const handleClick = (id, event) => {
    hiddenFileInput.current.click()
  }
  const handleSnackBarClose = () => {
    setOpenSnackBar(false)
  }
  const getTrimmedString = (text) => {
    if (text.split('.')[0].length > 30) {
      return text.split('.')[0].substr(0, 30) + '...' + text.split('.')[1]
    }
    return text
  }
  return (
    <div className={classes.layout}>
      <Upload></Upload>
      <Box className={classes.uploadfiledescription}>
        {uploadfiledescription}
      </Box>
      <FilledButton
        label={filename ? 'Re-Upload' : 'Upload'}
        width="100%"
        upload={true}
        onClick={(event) => handleClick(event)}
      ></FilledButton>

      {editFile ? (
        <Box className={classes.textlayout}>
          <Box className={classes.text}>
            {getTrimmedString(existingfilename)}
          </Box>
          <Box className={classes.downloadForm}>
            {' '}
            <DownloadForm PDFViewLink={existingfileurl}></DownloadForm>
          </Box>
        </Box>
      ) : filename ? (
        <Box className={classes.textlayout}>
          <Box className={classes.text}>{getTrimmedString(filename)}</Box>
        </Box>
      ) : (
        <Box className={classes.textlayout}>
          <Box className={classes.text}>File number limit : 1</Box>
          <Box className={classes.text}>Size limit : 10MB</Box>
          <Box className={classes.text}>Allowed File Types : PDF</Box>
        </Box>
      )}

      <input
        type="file"
        ref={hiddenFileInput}
        onChange={(event) => {
          if (
            event.target.files[0].type === 'application/pdf' &&
            event.target.files[0].size <= 10000000
          ) {
            setFileName(event.target.files[0].name)
            setEditFile(null)
            onValueChange(event.target.files[0])
          } else {
            setOpenSnackBar(true)
            if (event.target.files[0].type !== 'application/pdf')
              setSnackBarType('FILE_UPLOAD_TYPE')
            else setSnackBarType('FILE_SIZE_TYPE')
          }
        }}
        style={{ display: 'none' }}
      />
      {snackBarType ? (
        snackBarType === 'FILE_UPLOAD_TYPE' ? (
          <Snackbar
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            open={openSnackBar}
            onClose={handleSnackBarClose}
            key={'top' + 'center'}
          >
            <Alert onClose={handleSnackBarClose} severity="warning">
              Please upload files of PDF type
            </Alert>
          </Snackbar>
        ) : (
          <Snackbar
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            open={openSnackBar}
            onClose={handleSnackBarClose}
            key={'top' + 'center'}
          >
            <Alert onClose={handleSnackBarClose} severity="warning">
              Please upload files of size less than 10 MB
            </Alert>
          </Snackbar>
        )
      ) : null}
    </div>
  )
}
export default UploadFile
